<template>
  <div class="content">
    <input type="file" style="position: absolute;top: -99999px" id="fileUpload" @change="uploadChange">
    <div v-if="type == 'list'" class="filters">
      <div class="filtersList">
        <div class="status" v-for="(f, d) in filters" :key="d">
          <span class="sub">{{f.title}}</span>
          <p :class="{btn: true, selected: s.selected}" v-for="(s, si) in f.list" :key="si" @click="switchStatus(s, f)">
            {{s.title}}
          </p>
        </div>
      </div>
      <div class="pie">
        <div class="chart">
          <div :class="{rightHalf: pie.position === 'left', leftHalf: pie.position === 'right'}"></div>
          <div :class="{spinner: true, down: pie.position === 'right', up: pie.position === 'up'}" :style="{transformOrigin: '100% 50%', transform: `rotate(${pie.deg}deg)`}"></div>
        </div>
        <p class="detail">
          {{`使用量：${borrow.use}/${borrow.total}`}}
        </p>
      </div>
    </div>
    <div :class="{bg: true, empty: resources && resources.length === 0, delay: type == 'delay'}">
      <div v-if="type == 'delayStatic'" class="filterline">
        <div class="date">
          <span class="sub">
            使用日期
          </span>
          <date-picker range :disabled="disableCalendar" v-model="datePicker" placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        </div>
        <div class="btns">
          <p class="notice">
            <img src="@assets/img/resources/notice.png" alt="">
            <span>数据仅保留近{{days}}天</span>
          </p>
          <p class="btn greenBtn" @click="exportdelaydownload()">
            <img src="@assets/img/resources/export.svg" alt="fresh">
            <span>导出列表</span>
          </p>
        </div>
      </div>
      <div v-if="type == 'list'" class="filterline">
        <div class="date">
          <div class="filterBtn">
              <span @click="showFilter = !showFilter">{{orderListName}}</span>
              <i @click="showFilter = !showFilter"></i>

              <ul v-show="showFilter">
                  <li @click="sortChange(item)" :class="{on: item.selected}" v-for="item in orderList" :key="item.key">
                      <span>{{item.title}}</span>
                      <i></i>
                  </li>
              </ul>
          </div>
          <div @click="$InterviewTable('log')" class="log">操作日志</div>
          <div @click="exportResourceList" class="resourceList">导出设备列表</div>
        </div>
        <div class="btns">
          <p @click="downloadUrl(xls_url)" class="text">模板下载</p>
          <p @click="upload" class="btn">
            <img src="@assets/img/resources/multiAdd.png" alt="fresh">
            <span>批量添加</span>
          </p>
          <p @click="addExtraResource" class="btn greenBtn">
            <img src="@assets/img/resources/add.svg" alt="fresh">
            <span>添加</span>
          </p>
        </div>
      </div>
      <div class="backConfirmFilter" v-show="type == 'backConfirm'">
        <div class="globalFilter"><globalFilter ref="globalFilter1" /></div>
        <div class="btns">
          <p class="btn" @click="refresh()">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            <span>刷新</span>
          </p>
          <p class="btn greenBtn" @click="$InterviewTable('log1')">
            <img style="width: 18px;height: 18px" src="@assets/img/resources/clock.svg" alt="fresh">
            <span>操作记录</span>
          </p>
        </div>
      </div>
      
      <div v-show="type == 'backConfirm'" class="status" v-for="(f, d) in filters" :key="d">
        <span class="sub">{{f.title}}</span>
        <p :class="{btn: true, selected: s.selected}" v-for="(s, si) in f.list" :key="si" @click="switchStatus(s, f)">
          {{s.title}}
        </p>
      </div>
      <div v-show="type == 'delayStatic'" class="chart-container">
        <div class="chart">
          <p class="title">逾期比例</p>
          <div class="chartDom" ref="chart"></div>
        </div>
        <div class="chartTable">
          <p class="h">逾期TOP 5</p>
          <div class="headline">
            <span>逾期人</span>
            <span>所在部门</span>
            <span>逾期次数</span>
          </div>
          <div class="items">
            <div v-for="(item,index) in topList" :key="index" class="item">
              <span>{{item.username}}</span>
              <span>{{item.depart_title}}</span>
              <span>{{item.num}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="type == 'delayStatic'" class="staticDetail"> 
        <p class="title">详细统计</p>
        <div class="headline">
          <span>序号</span>
          <span>使用人</span>
          <span>所属部门</span>
          <span>逾期次数</span>
        </div>
        <div v-for="(item,index) in resources" :key="index" class="items">
          <div class="item">
              <span>{{item.id}}</span>
              <span>{{item.username}}</span>
              <span>{{item.depart_title}}</span>
              <span @click="showDetail(item.uid,index)">{{item.num}}<i :class="{on: item.isSelect}"></i></span>
          </div>
          <div v-if="item.minList && item.minList.length > 0" class="miniItem">
            <div class="headline">
              <span>任务主题</span>
              <span class="both">所属部门</span>
              <span class="once">设备名称</span>
              <span>到期时间</span>
              <span>逾期归还时间</span>
            </div>
            <div class="items">
              <div v-for="(items, key) in item.minList" :key="key" class="item">
                <span class="t" @click="toInterviewDetail(items.iview_id)">{{items.interveiw_title}}</span>
                <span class="both">{{items.depart_name}}</span>
                <span class="once">{{items.device_title}}({{items.device_idstring}})</span>
                <span>{{items.end}}</span>
                <span>{{items.return_time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="type == 'backConfirm'" :class="{titleline: true, backConfirm: true}">
        <span class="title">设备名称</span>
        <span class="num">设备编号<div class="arrow"><i @click="orderIndex = 0;page.pageIndex = 1;getList()" :class="{top: true, on: orderIndex == 0}"></i><i @click="orderIndex = 1;page.pageIndex = 1;getList()" :class="{bottom:true, on: orderIndex == 1}"></i></div></span>
        <span class="statusType">状态</span>
        <span class="endTime">到期时间<div class="arrow"><i @click="orderIndex = 2;page.pageIndex = 1;getList()" :class="{top: true, on: orderIndex == 2}"></i><i @click="orderIndex = 3;page.pageIndex = 1;getList()" :class="{bottom:true, on: orderIndex == 3}"></i></div></span>
        <span class="backTime">提交归还时间<div v-if="showReturn" class="arrow"><i @click="orderIndex = 4;page.pageIndex = 1;getList()" :class="{top: true, on: orderIndex == 4}"></i><i @click="orderIndex = 5;page.pageIndex = 1;getList()" :class="{bottom:true, on: orderIndex == 5}"></i></div></span>
        <span class="reporter">记者</span>
        <span class="intro">留言</span>
        <span class="file">附件</span>
        <span class="handles">操作</span>
      </div>
      <div v-if="type == 'list'" :class="{titleline: true, resourceList: true}">
        <span class="title">设备名称</span>
        <span class="num">设备编号</span>
        <span class="type">类型</span>
        <span class="statusType">状态</span>
        <span class="user">使用人/到期时间</span>
        <span class="handles">操作</span>
      </div>
      <div v-if="type == 'delay'" :class="{titleline: true, delay: true}">
        <span class="title">采访任务</span>
        <span class="reporter">记者</span>
        <span class="resource">延期设备</span>
        <span class="endTime">到期时间</span>
        <span class="endTime1">延期至时间</span>
        <span class="intro">理由</span>
        <span class="handles">操作</span>
      </div>
      <empty :mTop="50" :msg="'暂无资源数据'" v-if="resources && resources.length === 0" />
      <div :class="{items: true, yellow: resource.color == 'yellow', red: resource.color == 'red'}" v-for="(resource,key) in resources" :key="resource.title+key">
        <div v-if="type == 'backConfirm'" :class="{item: true, backConfirm: true}">
          <div @click="toDetail(resource.id)" :title="resource.title" class="title">
            {{resource.title}}
          </div>
          <div :title="resource.idstring" @click="toDetail(resource.id)" class="num">
            {{resource.idstring}}
          </div>
          <div class="statusType">
            {{resource.usingStatusName}}
          </div>
          <div class="endTime">
            {{resource.using_time}}
            <span v-if="resource.is_delay" class="red">(已逾期)</span>
          </div>
          <div class="backTime">
            {{resource.return_time}}
          </div>
          <div @click="showCard(resource.using_uid,$event)" class="reporter">
            {{resource.using_user}}
          </div>
          <div :title="resource.remark" class="intro">
            {{resource.remark}}
          </div>
          <div class="file">
            <img v-if="resource.img_url" @click="openViewer(resource.img_url)" :src="resource.img_url" alt="">
          </div>
          <div class="handles">
            <p v-if="resource.show_return" @click="backHandle(resource.id,0,resource)" class="g">入库</p>
            <p v-if="resource.notreturn" @click="backHandle(resource.id,1)">未归还</p>
            <p v-if="resource.show_outbound" @click="outHandle(resource.id)">出库</p>
            <!-- <p v-if="resource.is_delay">已逾期</p> -->
          </div>
        </div>

        <div v-if="type == 'list'" :class="{item: true, resourceList: true}">
          <div @click="toDetail(resource.id)" class="title">
            {{resource.title}}
          </div>
          <div @click="toDetail(resource.id)" class="num">
            {{resource.idstring}}
          </div>
          <div class="type">
            {{resource.type_title}}
          </div>
          <div class="statusType">
            {{resource.status_name}}
          </div>
          <div class="user">
            {{resource.using_info}}
          </div>
          <div class="handles">
            <p v-if="resource.status == 0" @click="startUse(resource)" class="g">启用</p>
            <p v-if="resource.status != 0 && resource.status != 2" @click="stopUse(resource)">停用</p>
            <p v-if="resource.status == 0" @click="delUse(resource)">删除</p>
          </div>
        </div>

        <div v-if="type == 'delay'" :class="{item: true, delay: true}">
          <div @click="toInterviewDetail(resource.iview_id)" class="title" :title="resource.title">
            {{resource.title}}
          </div>
          <div @click="showCard(resource.user_id, $event)" class="reporter">
            {{resource.user_name}}
          </div>
          <div class="resource">
            <span v-for="(item,index) in resource.logs" :key="index+1" :title="item.title">{{item.title}}</span>
          </div>
          <div class="endTime">
            <span v-for="(item,index) in resource.logs" :key="index+2">{{item.start}}</span>
          </div>
          <div class="endTime1">
            <span v-for="(item,index) in resource.logs" :key="index+3">{{item.end}}</span>
          </div>
          <div class="intro">
            <span v-for="(item,index) in resource.logs" :key="index+4" :title="item.remark">{{item.remark}}</span>
          </div>
          <div class="handles">
            <p @click="handle(resource.id, 0)" class="g">通过</p>
            <!-- <p class="g">停用</p> -->
            <p @click="handle(resource.id, 1)">退回</p>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      <resourceHandles ref="resourceHandles" />
      <addExtraResource @reload="reload" ref="addExtraResource" />
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import addExtraResource from '@components/addExtraResource'
import globalFilter from "@components/globalFilter";
import DatePicker from 'vue2-datepicker'
import resourceHandles from '@components/resourceHandles'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import * as echarts from 'echarts';

export default {
  name: 'resources',
  components: {
    pages, DatePicker, resourceHandles, empty, globalFilter, addExtraResource
  },
  data() {
    return {
      showReturn: false,
      xls_url: '',
      days: '',
      topList: [],
      orderList: [],
      orderIndex: 99,
      type: 'backConfirm',
      orderListName: '',
      showFilter: false,
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      resources: null,
      datePicker: [],
      icons: {
        driver: require('@assets/img/index/driver.svg'),
        bus: require('@assets/img/index/bus.svg'),
        camera: require('@assets/img/index/camera.svg')
      },
      filters: [],
      selectedStatus: {},
      searchOptions: {},
      filterOptions: {},
      disableCalendar: false,
      borrow: {
        use: 0,
        total: 0
      },
      pie: {
        position: 'left',
        deg: 0
      }
    }
  },
  computed: {
    getType() {
      console.log(this.$store.state.resourceType)
      return this.$store.state.resourceType;
    }
  },
  watch: {
    getType(to) {
      this.type = to
      this.orderIndex = 99
      this.page.pageIndex = 1;
      if(this.type != 'delayStatic'){
        this.getList()
      }else{
        this.getChart() 
        this.getDelayusers()
      }
    },
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.page.pageIndex = 1
        this.filterOptions['start'] = this.getDayStart(n[0])
        this.filterOptions['end'] = this.getDayEnd(n[1])
        if(this.type == 'delayStatic'){
          this.getChart() 
          this.getDelayusers()
          // this.getList()
        }
      }
    },
    filterOptions: {
      handler(n, o) {
        const status = n['status'] || ''
        if (status == 2) {
          this.disableCalendar = true
        } else {
          this.disableCalendar = false
        }
      },
      deep: true
    }
  },
  methods: {
    outHandle(id) {
      let formData = {
        id: id
      }
      // formData.append("upload_data",file)
      common.myFetch(apis.getExpanddeviceByDeviceid, formData).then(res => {
        if(res){
          console.log(res)
          let config = {
            list: res.list,
            id: res.iview_id
          }
          this.$equipOut(config).then(result => {
            if(result){
              this.getList()
            }
          })
          // this.$UploadTable(res)
        }
      })
    },
    upload() {
      var fileUpload = document.querySelector("#fileUpload");
      fileUpload.click()
    },
    uploadChange() {
      var file = document.querySelector("#fileUpload").files[0]
      let formData = {
        upload_data: file
      }
      // formData.append("upload_data",file)
      common.myFetch(apis.Resource_upload, formData).then(res => {
        if(res){
          this.$UploadTable(res)
        }
      })
      // var reader = new FileReader()
      // reader.readAsDataURL(file)
      // reader.onload = function() {
      //   var data = {}
      //   data.file = reader.result

      //   console.log(reader)
      // }
      // console.log(file)
    },
    downloadUrl() {
      // var link,
      // evt;
  
      // link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', '');
      // if(document.fireEvent) {
      //     window.open(link.href);
      // }else {
      //     evt = document.createEvent('MouseEvents');
      //     evt.initEvent('click', true, true);
      //     link.dispatchEvent(evt);
      // }
      const url = apis.Resource_downloadtemp
      const userKeys = common.userKeys()
      const params = Object.assign({}, userKeys)
      // const url = apis.Res_resource_list + common.obj2Str(params)
      //
      // window.open(url)
      common.exportRes(url, params)
    },
    useDevice(id, status, remark) {
      // 设备操作接口
      const info = {
        device_id: id,
        status: status, // -1:删除，0:停用，1启用
        remark: remark
      }

      common.myFetch(apis.Res_device_use, info)
      .then((data)=>{
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    },
    async stopUse(l) {
      // 设备停用弹窗
      // const c = await this.$confirm('确认停用吗？')
      // if (!c) return

      this.$Dialog({
          title: '停用备注',
          placeholder: '请输入停用情况',
          errTitle: '无需输入',
          canEdit: true,
          singleBtn: true,
          maxLength: 20
        }).then(res => {
          if(res) {
            console.log(res)
            let remark = ''
            if(res != 'null'){
              remark = res
            }

            this.useDevice(l.id, 0, remark)
          }
        })

      // this.useDevice(l.id, 0)
    },
    async startUse(l) {
      // 设备启用弹窗
      // const c = await this.$confirm('确认启用吗？')
      // if (!c) return
      this.$Dialog({
          title: '启用备注',
          placeholder: '请输入启用情况',
          errTitle: '无需输入',
          canEdit: true,
          singleBtn: true,
          maxLength: 20
        }).then(res => {
          if(res) {
            console.log(res)
            let remark = ''
            if(res != 'null'){
              remark = res
            }

            this.useDevice(l.id, 1, remark)
          }
        })

      // this.useDevice(l.id, 1)
    },
    async delUse(l) {
      // 设备启用弹窗
      const c = await this.$confirm('确认删除吗？')
      if (!c) return

      this.useDevice(l.id, -1)
    },
    showDetail(uid,index) {
      if(!this.resources[index].isSelect) {
        this.resources.forEach(el => {
          el.minList = []
        })
        this.getDelayuserlist(uid,index)
      }else{
        this.resources[index].minList = []
      }

      this.resources[index].isSelect = !this.resources[index].isSelect
    },
    getDelayuserlist(uid,index) {
      let info = {
        user_id: uid,
        start: this.filterOptions['start'],
        end: this.filterOptions['end']
      }

      common.myFetch(apis.Delay_userlist, info).then(res => {
        console.log(res)
        this.resources[index].minList = res.list
      })
    },
    getDelayusers() {
      let info = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        start: this.filterOptions['start'],
        end: this.filterOptions['end']
      }

      common.myFetch(apis.Delay_users, info).then(res => {
        console.log(res)
        res.list.forEach(el => {
          el.minList = []
          el.isSelect = false
        })
        this.resources = res.list
        this.$set(this.page, 'page_count', common.calculatePage(res.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', res.page.row_count - 0)
      })
    },
    getChart() {
      let info = {
        start: this.filterOptions['start'],
        end: this.filterOptions['end']
      }

      common.myFetch(apis.Delay_data, info)
      .then((r) => {
        if (r) {
          console.log(r)
          this.topList = r.topList;
          this.days = r.days;
          var chartDom = this.$refs.chart;
          var myChart = echarts.init(chartDom);
          var option;
          let arr = []

          arr.push({
              name: '使用次数',
              value: r.totalNum
          })

          arr.push({
              name: '逾期次数',
              value: r.delayNum
          })

          option = {
              color: ['#5B8FF9', '#9AAFD9', '#D9E2F4', '#A4C1FF', '#73c0de', '#3ba272', '#fc8452', '#9a60b41', '#ea7ccc'],
              tooltip: {
                  trigger: 'item'
              },
              legend: {
                  orient: 'vertical',  //垂直显示
                  y: 'center',    //延Y轴居中
                  x: '75%'
              },
              series: [
                  {
                      name: '',
                      type: 'pie',
                      radius: ['40%', '70%'],
                      avoidLabelOverlap: false,
                      label: {
                          show: false,
                          position: 'center'
                      },
                      emphasis: {
                          label: {
                              show: true,
                              fontSize: '12',
                              fontWeight: 'bold'
                          }
                      },
                      labelLine: {
                          show: false
                      },
                      data: arr
                  }
              ]
          };

          option && myChart.setOption(option);
        }
      })
    },
    openViewer(src) {
      this.$viewer([], {url: src,type: 1});
    },
    backHandle(id, status, detail) {
      let remark = ''
      if(status == 0){
        this.$equipCheck(detail).then(res => {
          if(res) {
            if(res == 'null'){
              res = ''
            }
            remark = res
            let info = {
              device_id: id,
              status: status,
              remark: remark
            }

            common.myFetch(apis.Return_device1, info)
            .then((r) => {
              if (r) {
                this.$toast(r)
                this.page.pageIndex = 1;
                this.getList()
              }
            })
          }
        })
      }else{
        let info = {
          device_id: id,
          status: status,
          remark: remark
        }

        common.myFetch(apis.Return_device1, info)
        .then((r) => {
          if (r) {
            this.$toast(r)
            this.page.pageIndex = 1;
            this.getList()
          }
        })
      }
    },
    handle(id, status) {
      let remark = ''
      if(status == 1){
        this.$Dialog({
          title: '退回理由',
          placeholder: '请输入理由',
          errTitle: '无需输入',
          canEdit: true,
          singleBtn: true,
          maxLength: 20,
          double: true
        }).then(res => {
          if(res) {
            remark = res
            let info = {
              id: id,
              status: status,
              remark: remark
            }

            common.myFetch(apis.Delay_pass, info)
            .then((r) => {
              if (r) {
                this.$toast(r)
                this.page.pageIndex = 1;
                this.getList()
              }
            })
          }
        })
      }else{
        let info = {
          id: id,
          status: status,
          remark: remark
        }

        common.myFetch(apis.Delay_pass, info)
        .then((r) => {
          if (r) {
            this.$toast(r)
            this.page.pageIndex = 1;
            this.getList()
          }
        })
      }

      
    },
    toDetail(id) {
      common.jump('/extraEquipmentDetail?d='+id,true)
    },
    toInterviewDetail(id) {
      common.jump('/interviewDetail?r='+id,true)
    },
    reload() {
      this.page.pageIndex = 1;
      this.getList()
    },
    sortChange(item) {
        this.orderListName = item.title;
        this.showFilter = false;
        this.$set(this.filterOptions, 'order_by', item.key)
        this.page.pageIndex = 1;
        this.getList()
        // let data = {
        //     orderBy: item.key
        // }
        // this.getFilters(data)
    },
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    remarkFocus(rsc) {
      this.$nextTick(() => {
        this.$set(rsc, 'showRmkConfirm', true)
      })
    },
    remarkBlur(rsc) {
      this.$set(rsc, 'showRmkConfirm', false)
    },
    timeFocus(rsc) {
      this.$nextTick(() => {
        this.$set(rsc, 'showConfirm', true)
      })
    },
    timeBlur(rsc) {
      this.$set(rsc, 'showConfirm', false)
      // this.getList()
    },
    confirmRmk(rsc) {
      // 确认提交备注
      const info = {
        iview_id: rsc.id,
        remark: rsc.remark
      }

      common.myFetch(apis.Res_modify_remark, info)
      .then((r) => {
        if (r) {
          this.$toast(r)
          this.$set(rsc, 'showRmkConfirm', false)
        }
        this.getList()
      })
    },
    confirmTime(rsc) {
      // 确认修改时间
      const info = {
        start: `${rsc.start}:00`,
        end: `${rsc.end}:00`,
        iview_id: rsc.id
      }

      common.myFetch(apis.Res_modify_time, info)
      .then((r) => {
        if (r) {
          this.$toast(r)
          this.$set(rsc, 'showConfirm', false)
        }
        this.getList()
      })
    },
    initTomorrow() {
      const tomorrow = this.getTomorrow()

      this.datePicker = tomorrow
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 23:59:59`
    },
    getDayStart(s) {
      // 获取当天的开始时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 00:00:00`
    },
    getTomorrow() {
      // 获取明天时间戳
      const today1 = new Date()
      const today = +new Date()
      const year1 = today1.getFullYear()
      const month1 = today1.getMonth() + 1
      const day1 = today1.getDate()
      const tomarrow = new Date(today-1000*60*60*24*day1)
      console.log(tomarrow)
      const year = tomarrow.getFullYear()
      const month = tomarrow.getMonth() + 1
      const day = tomarrow.getDate()
      const startSec = new Date(`${year}-${month}-${1} 00:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 23:59:59`)

      return [startSec, endSec]
    },
    goItv(i) {
      // 跳转采访详情
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/interviewDetail?r=${i}`, true)
    },
    getList(keyWord) {
      //  获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        order_by: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        
      }

      if(this.filterOptions.using_status == 0){
        this.showReturn = true
      }else{
        this.showReturn = false
        if(this.orderIndex == 4 || this.orderIndex == 5){
          this.orderIndex = 2
        }
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      if(this.type == 'backConfirm'){
        if(this.orderIndex != 99){
          console.log(this.orderList.list[this.orderIndex].key)
          info.order_by = this.orderList.list[this.orderIndex].key
        }
        info.start = ''
        info.end = ''
        common.myFetch(apis.Resource_returnlist, info)
        .then((data) => {
          this.$store.commit('changeRed', data.icon)
          data.params.list_search.forEach(el => {
            if(el.key == 'order_by'){
              this.orderList = el
              el.list.forEach((item, index) => {
                if(item.selected){
                  this.orderIndex = index
                }
              })
            }
          })
          this.resources = data.list
          this.generateFilters(data.params.list_search)
          this.borrow = {
            use: data.use_num - 0,
            total: data.total_num - 0
          }
          this.calculatePie()
          this.generateSearchs(data.params.top_search.option.list)
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        })
      }else if(this.type == 'delay'){
        info.page_type = 'resource'
        common.myFetch(apis.Delay_verify, info)
        .then((data) => {
          this.$store.commit('changeRed', data.icon)
          this.resources = data.list
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        })
      }else if(this.type == 'list'){
        info.start = ''
        info.end = ''
        common.myFetch(apis.Expand_list, info)
        .then((data) => {
          this.xls_url = data.xls_url
          data.params.list_search.forEach(el => {
            if(el.key == 'order_by'){
              this.orderList = el.list
              el.list.forEach((item, index) => {
                if(item.selected){
                  this.orderListName = item.title
                }
              })
            }
          })
          this.resources = data.list
          this.generateFilters(data.params.list_search)
          this.borrow = {
            use: data.using - 0,
            total: data.total - 0
          }
          this.calculatePie()
          if(this.type == 'backConfirm'){
            this.generateSearchs(data.params.top_search.option.list)
          }
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        })
      }
    },
    calculatePie() {
      // 计算并绘制饼图
      const u = this.borrow.use        // 借出数
      const t = this.borrow.total      // 总数
      const r = (u/t)*100              // 系数
      // 默认（度数为0）时，遮罩（绿色）位于左侧，转头位于左侧（置于下方）
      if(r >= 50) {                    // 系数大于等50，转头置于上方，由180 - 360度旋转；遮罩（白色）位于右侧
        this.pie.position = 'left'
      } else {                         // 系数小于50，转头置于下方，由0 - 180度旋转；遮罩（绿色）位于左侧
        this.pie.position = 'right'
      }

      this.pie.deg = r * 3.6
    },
    generateFilters(data) {
      // 整理过滤项数据
      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end' && i.key !== 'order_by' 
      })

      this.filters = filters
    },
    generateSearchs(data) {
      // 整理搜索框数据并传递
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }

      this.$refs.globalFilter1.getData(filterData);
      // this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送过滤器数据
      this.$emit('filterData', data)
    },
    switchStatus(s, l) {
      // 切换过滤器选项
      if (s.selected) return

      this.page.pageIndex = 1

      l.list.forEach((i) => {
        this.$set(i, 'selected', false)
      })

      this.$set(s, 'selected', true)
      this.$nextTick(() => {
        // this.filterOptions[l.key] = s.key
        this.$set(this.filterOptions, l.key, s.key)
        this.getList()
      })
    },
    openHandle(res, id, name, list) {
      if (res.status != 1) return
      // 打开资源分配窗口
      const info = {
        title: res.title,
        interviewId: res.id,
        typeId: id,
        type: name,
        list: list,
        origin: res
      }

      this.$refs.resourceHandles.open(info)
      .then(r => {
        if (r) {
          this.getList()
        }
      })
    },
    async handleResource(r, s) {
      // 分配／退回 操作
      let msg = ''
      const notMatch = r.cameras.list.length !== r.cameras.num - 0 || r.cars.list.length !== r.cars.num - 0 || r.drivers.list.length !== r.drivers.num - 0

      if (s === 1) {
        if (notMatch) {
          msg = '已选资源与所需求的不匹配，确认完成吗？'
        } else {
          msg = '确认完成吗？'
        }
      } else {
        msg = '确认退回吗？'
      }

      const c = await this.$confirm(msg)
      if (!c) return

      const info = {
        iview_id: r.id,
        is_finish: s // 1:完成 2:退回
      }

      common.myFetch(apis.Res_resource_handle, info)
      .then((data) => {
        this.$toast(data)
        this.getList()
      })
    },
    refresh() {
      // 刷新
      window.location.reload()
    },
    exportRes() {
      // 导出
      const info = {
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: 'download'
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.searchOptions, this.filterOptions)
      const url = apis.Res_resource_list
      // const url = apis.Res_resource_list + common.obj2Str(params)
      //
      // window.open(url)
      common.exportRes(url, params)
    },
    exportResourceList() {
      // 导出
      const info = {
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: 'download'
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.searchOptions, this.filterOptions)
      const url = apis.Resource_downloadexpand
      // const url = apis.Res_resource_list + common.obj2Str(params)
      //
      // window.open(url)
      common.exportRes(url, params)
    },
    exportdelaydownload() {
      // 导出
      const info = {
        start: this.filterOptions['start'],
        end: this.filterOptions['end']
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)
      const url = apis.Resource_delaydownload
      // const url = apis.Res_resource_list + common.obj2Str(params)
      //
      // window.open(url)
      common.exportRes(url, params)
    },
    addExtraResource() {
      this.$refs.addExtraResource.open(2)
    }
  },
  mounted() {
    this.type = this.$store.state.resourceType
    this.getList()
    this.initTomorrow()
    // this.$refs.addExtraResource.open(2)
    // this.$InterviewTable()
  }
}
</script>

<style lang="less" src="@assets/css/resource/tuozhanshebei.less" scoped></style>
